export const getSessionStorage = (key, defaultValue) => {
    const storedValue = sessionStorage.getItem(key);
    return storedValue ? JSON.parse(storedValue) : defaultValue;
};

export const setSessionStorage = (key, value) => {
    sessionStorage.setItem(key, JSON.stringify(value));
};
